import {Provider} from "./provider";
import {Event} from "../event";
import {log} from "../../util/log";

interface IGA4Event {
    event: 'ga4_event';
    eventCategory: "";
    eventAction: "";
    eventLabel: "";
    ga4_event_name: string;
    ga4_action_name: string;
    ga4_tag_name: string;
}

export class GA4Provider extends Provider<IGA4Event> {
    /* STATIC */

    /* INSTANCE */
    public override parse(data: Event): IGA4Event {
        return {
            event: 'ga4_event',
            eventCategory: '',
            eventAction: '',
            eventLabel: '',
            ga4_event_name: 'cmp',
            ga4_action_name: data.action,
            ga4_tag_name: data.label
        };
    }

    public override send(data: IGA4Event): void {
        if ((window as any)['dataLayer']) {
            (window as any)['dataLayer'].push(data);
        } else {
            log.debug('dataLayer not found');
        }
    }
}
